import { Component, OnInit, ViewChild, ElementRef, Input } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { IComponent } from '../../interfaces';

// services
import * as srv from '../../services';
// Enums
import { MessageTypeEnum } from '../../enums';
@Component({
	selector: 'app-terms',
	templateUrl: './terms.component.html',
	styleUrls: ['./terms.component.scss']
})
export class TermsComponent implements IComponent, OnInit {
	// implement icomponent
	name = 'TermsComponent';
	subscriptions: Subscription[] = [];

	// implement local
	@ViewChild('terms') terms: ElementRef;
	@ViewChild('checkbox') checkbox: ElementRef;
	@Input() SRC: string;
	assetFolder = 'assets/_templates/';
	html: string;
	agreed = false;
	url: string;

	constructor(
		private _helperSrv: srv.HelperService,
		private _logSrv: srv.LogService,
		private _msgSrv: srv.MessageService,
		private _applicationSrv: srv.ApplicationService
	) {
		this.url = _helperSrv.getTerms();

	}

	ngOnInit() {
		this._loadHtml(this.url);
		// $('applicationOuterContainer').live
	}

	OnCheckBoxClick(c) {
		this._logSrv.Debug(this.name, ['OnCheckBoxClick', c]);
		this.agreed = c.checked;
		this._applicationSrv.Terms = this.agreed;
		// this._msgSrv.DisplayLocalMessage(
		//   this.name,
		//   {
		//     message: 'Please Check the box to the left to agree',
		//     isError: true,
		//     type: MessageTypeEnum.headsup
		//   }
		// );

	}

	private _loadHtml(url: string) {
		if (url !== undefined) {
			const source = url;
			const x = 'https://view.officeapps.live.com/op/embed.aspx?src=' + url;
			// 'http://docs.google.com/gview?url=' + url + '&embedded=true';
			this._logSrv.Debug(this.name, ['_loadHtml', source, x]);
			this.html = '<iframe id="termsframeid" style="border: 1px solid gray; min-width: 200px; width:100%; height:350px" src="' + x + '"></iframe>';
			this.terms.nativeElement.innerHTML = this.html;
			this._logSrv.Debug(this.name, ['_loadHtml', this.terms.nativeElement]);
		} else {
			this.html = `<div>no document located at ${url}</div>`;
			this.terms.nativeElement.innerHTML = this.html;
		}
	}
}



// WEBPACK FOOTER //
// C:/AZURE/ACEP/Acep.Crm.WebPortal/CrmWebPortalGlobal/Membership/AngularApps/PACED/PACEDAngular/src/app/share/components/terms/terms.component.ts